import { api } from "@/APIRequests";
import type { Note, UUID } from "@/core/types";

export async function getNotesSummary(patientId: UUID): Promise<Note[]> {
  return api.sharedTyped.get_notes_summary({ params: { showLoader: false }, patientId });
}
